<template>
<div>
  <!-- <div class="login2" v-if="domain>-1">
    <div :style="{background:themeColor.header_times_background_color}">
      <login-header></login-header>
    </div>
    <div class="content">
      <login-login></login-login>
    </div>
    <div class="copyright" :style="{background:themeColor.copy_background_color}">
       <span :style="{color:themeColor.copy_text_color}">@ 2022 Times E-Commerce Limited. All Rights Reserved</span>
    </div>
  </div> -->
   <div class="login">
    
    <div :style="{background:themeColor.header_background_color}">
      <login-header></login-header>
    </div>
    <div class="content">
      <login-login></login-login>
    </div>
    <div class="copyright" :style="{background:themeColor.copy_background_color}">
       <div :style="{color:themeColor.copy_text_color}">
         &copy; Kerry Logistics Network Limited. All Rights Reserved.
         <div style="color: #ccc;">System Version: {{ buildVersion }} {{ buildTime }}</div>
       </div>
    </div>
  </div>
 </div> 
</template>

<script>
import {mapState} from 'vuex'
import loginHeader from './components/header'
import loginLogin from './components/login'
  export default {
    name:'login',
    props:[''],
    components:{
      loginHeader,
      loginLogin
    },
    data() {
      return {
        domain:window.location.host.indexOf('stg.as2.kec-app.com'),
        buildTime: null,
        buildVersion: null,
      };
    },
    mounted() {
      this.buildTime = document.documentElement.dataset.buildTimestampUtc;
      this.buildVersion = this.application_version;
    },
    computed: {
      ...mapState('home',['themeColor']),
    },
    mounted(){
    },
    methods: {
    },


  }

</script>
<style lang='stylus' scoped>
 .login
   min-width 100vw
   min-height 100vh
   background url("~@/assets/images/bj.jpg") no-repeat
   background-size cover
   .content
     width 100%
     height calc( 100vh - 118px )
     background rgba(0,0,0,.4)
     position relative
   .copyright
     width 100%
     height 48px
     line-height 24px
     font-size 14px
     text-align center
     opacity .5
     z-index 2
 .login2
   min-width 100vw
   min-height 100vh
   background url("~@/assets/images/bg_times.jpg") no-repeat 
   background-size cover
   .content
     width 100%
     height calc( 100vh - 110px )
     background rgba(0,0,0,.4)
     position relative
   .copyright 
     width 100%
     height 40px
     line-height 40px 
     text-align center
     opacity .5
     z-index 2
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue